import { useEffect } from 'react';
import { AuthLayoutPropsType } from './types';
import AuthRoutes from '../../Routes';
import { StyledContainer } from './styled';
import { Container } from './styled';
import useGetClientConfigs from '@Api/clients/hooks/useGetClientConfigs';

const AuthLayout: React.FC<AuthLayoutPropsType> = () => {
	useEffect(() => {
		document.body.classList.add('bg-white');
		return () => {
			document.body.classList.remove('bg-white');
		};
	}, []);

	const { data } = useGetClientConfigs();

	return (
		<StyledContainer>
			{/* begin::Content */}
			<div className="d-flex flex-center flex-column justify-content-center align-items-center flex-column-fluid p-10 ">
				{/* begin::Logo */}
				<div
					className="d-flex justify-content-center align-items-center"
					style={{
						marginBottom: 48,
					}}
				>
					{data?.logo_image_url && (
						<img
							src={data.logo_image_url}
							style={{
								maxWidth: 256,
							}}
						/>
					)}
				</div>
				{/* end::Logo */}
				{/* begin::Wrapper */}
				{/* <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto  w-sm-500px w-xs-500px w-md-500px"> */}
				<Container>
					<AuthRoutes />
				</Container>
				{/* end::Wrapper */}
			</div>

			{/* end::Content */}
			{/* begin::Footer */}
		</StyledContainer>
	);
};

export default AuthLayout;
